import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { ConvertSafesDto } from '../../types/safes.types';
import { useIdempotentAppMutation } from '../use-idempotent-app-mutation.hook';

export const useConvertSafes = () => {
  const { mutate: convert, isPending } = useIdempotentAppMutation([QueryKey.CONVERT_SAFES], {
    mutationFn: ({ companyId, data }: { companyId: string; data: ConvertSafesDto }, { headers }) =>
      ApiService.post(
        { endpoint: BackendRoute.COMPANIES, routePath: [companyId, 'safes', 'convert-to-shares'] },
        {
          body: { ...data, safes: data.safes.map(({ id, filesLinks }) => ({ id, filesLinks })) },
          headers,
        },
      ),
  });
  return { convert, isPending };
};
